module.exports = __webpack_public_path__ + "img/correct.5c4d7bff.png";